<template>
  <div id="app">
    <main-menu-button @open="toggleMenu" :show-menu="showMenu" />
    <transition name="fade">
      <mobile-navigation v-if="showMenu" @close="toggleMenu(false)" />
    </transition>

    <name />
    <about id="about" />
    <experience id="experience" />
    <projects id="projects" />
    <contact id="contact" />
  </div>
</template>
<script>
import Name from "./components/Name";
import About from "./components/About";
import MainMenuButton from "./components/widget/MenuButton";
import MobileNavigation from "./components/MobileNavigation";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Contact from "./components/Contact";

export default {
  components: {
    Name,
    About,
    MainMenuButton,
    MobileNavigation,
    Experience,
    Projects,
    Contact,
  },
  data() {
    return {
      showMenu: false,
    };
  },
  watch: {
    showMenu() {
      if (this.showing) {
        document.documentElement.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = "auto";
      }
    },
  },
  methods: {
    toggleMenu(showMenu) {
      this.showMenu = showMenu;
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
